<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
  

      window.openIns = function (){
        // gtag('event', 'click_ins',{
        //   'event_name': 'openIns'
        // });
        window.open("https://www.instagram.com/allsports_france/");
      }
      window.openFacebook = function (){
        // gtag('event', 'click_facebook',{
        //   'event_name': 'openFacebook'
        // });
        window.open("https://www.facebook.com/allsportsfr/");
      }
      window.openLine = function (){
      // fbq('track', 'Contact', {content_category: "line"});
        // gtag('event', 'click_whatsapp',{
        //   'event_name': 'openWhatsapp'
        // });
        var numbers = "33759533900"
        window.location.href = "https://wa.me/" + numbers;
        setTimeout(function () {
            window.location.href = 'https://api.whatsapp.com/send?phone=' + numbers;
            window.location.href = 'https://api.whatsapp.com/send?phone=' + numbers;  

        }, 2000)

        // var lineAddress = "https://line.me/ti/p/k_n4-Qy5Em";
        // window.open(lineAddress);
      }
      window.openMail = function (){
        // gtag('event', 'click_mail',{
        //   'event_name': 'openMail'
        // });
        window.location.href = "mailto:melanie.d@asports.fr";
      }
      window.openPhone = function (){
        window.location.href = "tel:+330759533900"
      }
     
      // if(!localStorage.getItem("salesman")){
      //   localStorage.setItem("salesman", "aimee");
      // }
      //   写入ad_source
      if(location.href.indexOf('utm_source') != -1 || location.href.indexOf('gclid') != -1){
        localStorage.setItem("ad_source", location.href);
      }

      // var pageTop = $('#return-top');
      // // pageTop.hide();
      // $(window).scroll(function () {
      //     if ($(this).scrollTop() > 600) {
      //       pageTop.addClass("fadeIn")
      //       {% if template == 'index' %}
      //       $(".media-menu").removeClass("el-hidden")
      //       {% endif %}
      //     } else {
      //       pageTop.removeClass("fadeIn")
      //       {% if template == 'index' %}
      //       $(".media-menu").addClass("el-hidden")
      //       {% endif %}
      //     }
      // });
      // $("#return-top").click(function(){
      //   $("html,body").animate({scrollTop: 0}, 700);
      // })


     // page sidebar
    $(".custom-page-sidebar .icon-dropdown").click(function(){
    console.log(111)
    if($(this).parent(".navPages-item").hasClass("is-clicked")){
      $(this).parent(".navPages-item").removeClass("is-clicked")
      $(this).siblings(".dropdown-category-list").css("display","none")
    }else{
      $(this).parent(".navPages-item").addClass("is-clicked")
      $(this).siblings(".dropdown-category-list").css("display","block")
    }
  })


    //  font-color-modal.liquid
   window.openFontColor = function (str){
    $(".font-color-bg-fixed").css({opacity:1,zIndex: 140});
    $("#font-color").css({opacity:1,visibility:"visible",zIndex: 140});
    $(".background-overlay").css({"opacity":1,"pointer-events":"all"});
    if(str){
      var el = "#" + str;
      var calc_distance = $(el).offset().top - $("#font-color").offset().top
      $("#font-color").animate({scrollTop: calc_distance}, 1000);
    }else{
      $("#font-color").animate({scrollTop: 0}, 1000);
    }
    
  }
    $(".bespoke-halo-popup-close").click(function(){
      $(".font-color-bg-fixed").css({opacity:0,zIndex: -1});
      $("#font-color").css({opacity:0,visibility:"hidden"});
      $(".background-overlay").css({"opacity":0,"pointer-events":"none"})
      $("#font-color").animate({scrollTop: 0}, 1000);
    })
  
    $('.font-color-bg-fixed').on('click',function (e) {
        var obj = $(e.target);
        if(obj.closest("#font-color").length < 1){
          $(".font-color-bg-fixed").css({opacity:0,zIndex: -1});
          $("#font-color").css({opacity:0,visibility:"hidden"});
          $(".background-overlay").css({"opacity":0,"pointer-events":"none"})
          $("#font-color").animate({scrollTop: 0}, 1000);
        }
    });


  // product-page.liquid
    window.toForm = function (){
      $("html,body").animate({scrollTop: $("#order_consult").offset().top - 30}, 1000);
    }
    $(".pro-info-wrap .title").click(function(){
      if($(this).hasClass("close")){
        $(this).siblings(".bg-color").removeClass("close")
        $(this).removeClass("close")
      }else{
        $(this).siblings(".bg-color").addClass("close")
        $(this).addClass("close")
      }
      
    })

  window.openCustomModal = function (str){
      $(".bg-fixed").css({opacity:1,zIndex: 140});
      var el = "#"+str;
      if(str == 'fabric_1'){
        $("#fabric_2-bg").css("display","none");
        $("#fabric_3-bg").css("display","none");
        $("#fabric_1-bg").css("display","block");
      }
      if(str == 'fabric_2'){
         $("#fabric_1-bg").css("display","none");
        $("#fabric_3-bg").css("display","none");
        $("#fabric_2-bg").css("display","block");
      }
      if(str == 'fabric_3'){
        $("#fabric_1-bg").css("display","none");
        $("#fabric_2-bg").css("display","none");
        $("#fabric_3-bg").css("display","block");
      }
      $(el).css({opacity:1,visibility:"visible",zIndex: 140});
      $(".background-overlay").css("opacity",1);
    }
    $(".custom-halo-popup-close").click(function(){
      $(".bg-fixed").css({opacity:0,zIndex: -1});
      $(".custom-modal").css({opacity:0,visibility:"hidden"});
      $(".background-overlay").css("opacity",0)
      $(".custom-modal").animate({scrollTop: 0}, 1000);
    })
    $('.bg-fixed').on('click',function (e) {
      var obj = $(e.target);
      if(obj.closest(".custom-modal").length < 1){
        $(".bg-fixed").css({opacity:0,zIndex: -1});
        $(".custom-modal").css({opacity:0,visibility:"hidden"});
        $(".background-overlay").css("opacity",0)
        $(".custom-modal").animate({scrollTop: 0}, 1000);
      }
  });
  window.toFullyCustom = function (){
    // gtag('event', 'click_fully_custom', {
    //         'event_name' : 'fully_custom'
    // });
    window.location.href = "/pages/oem-odm";
  }



  //  swatch-product.liquid

      window.parseFormatNum = function (number){
      var sub_val = (number + "").split("").reverse();
      var show_html = "";
      for (i = 0; i < sub_val.length; i++) {
         if((i+1) % 3 == 0 && (i+1) != sub_val.length){
           show_html += sub_val[i] + ",";
         }else{
           show_html += sub_val[i];
         }
         
      }
     return show_html.split("").reverse().join("");

  }
    window.calcPrice = function (index){
      $('.money').each(function(i){
          var prc = $(this).attr("data-price") * 1;
          var price = null;
          var sale = null;
        if(index == 0){
          price = prc / 100;
        }else if(index == 1){
           sale = "25% OFF";
           price = prc * 0.75 / 100;
          }else if(index == 2){
            sale = "30% OFF";
            price = prc * 0.7 / 100;
          }else if(index == 3){
            sale = "35% OFF";
            price = prc * 0.65 / 100;
          }
          price = Math.floor(price)
          // console.log(price)
           if(sale)$(".discount_num").html(sale)
          $(this).html("￥"+ parseFormatNum(price)+"-");
        })
      if($('.money-fluorescent') && $('.money-fluorescent').length > 0){
        $('.money-fluorescent').each(function(i){
          var prc = $(this).attr("data-price") * 1;
          var price = null;
          var sale = null;
        if(index == 0){
          price = prc / 100;
        }else if(index == 1){
           sale = "25% OFF";
           price = prc * 0.75 / 100;
          }else if(index == 2){
            sale = "30% OFF";
            price = prc * 0.7 / 100;
          }else if(index == 3){
            sale = "35% OFF";
            price = prc * 0.65 / 100;
          }
          price = Math.floor(price)
          // console.log(price)
           if(sale)$(".discount_num").html(sale)
          $(this).html("蛍光色 +￥"+ parseFormatNum(price));
        })
      }
    }
    window.calcSale = function (index){
        $(".sale_num").eq(index).addClass('select_sale').siblings().removeClass("select_sale");
        $(".sale_num").eq(index).addClass('select_sale').siblings().removeClass("select_sale");
      if(index == 0){
        $(".discount_num").css("visibility","hidden");
        $(".origin_price").css("display","none");
      }else{    
        $(".discount_num").css("visibility","visible");
        $(".origin_price").css("display","block");
      }
      calcPrice(index)
    }
    window.selectOption = function (index){
        $(".sex_option").eq(index-1).addClass('active').siblings().removeClass("active");
        $(".size_def").eq(index-1).addClass('size_active').siblings().removeClass("size_active");
      }
